import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';

import './link-list.scss';

const COMPONENT_NAME = 'link-list';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (LinkList)
 */
export class LinkList {
  constructor() {
    const self = this;

    this._els = {
      linkList: $(`.${BEM.BLOCK}`),
    };

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.linkList.each(function () {
        const $instanceEl = $(this);
        TextColorCheck._checkBackground($instanceEl);
      });
    });
  }
}
